import { Banner, Link, Stack, Typography } from '@optimus-web/core';
import { lt, useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { useUpdateGoLiveDate } from './goLiveDatePicker/useUpdateGoLiveDate';

interface GoLiveDateBannerProps {
    variant: 'warning' | 'error';
    condition: boolean;
    bannerText: React.ReactNode;
}

export const GoLiveDateBanner = ({ variant, condition, bannerText }: GoLiveDateBannerProps) => {
    const [renderUpdateGoLiveDateDialog, toggleUpdateGoLiveDateDialog] = useUpdateGoLiveDate();
    const isOnboardingAuditEditGoLiveDateEnabled = useFeatureFlag(FeatureFlag.onboardingAuditEditGoLiveDateEnabled);
    const shouldShow = isOnboardingAuditEditGoLiveDateEnabled && condition;

    if (!shouldShow) return null;

    return (
        <>
            <Banner
                secondaryText={
                    <Stack spacing="100" vertical>
                        {bannerText}
                        <Typography as="div" textStyle="bodyMediumStrong">
                            <Link onClick={toggleUpdateGoLiveDateDialog} variant="basic">
                                {lt('OnboardingAuditTimelineGoLiveBannerLink')}
                            </Link>
                        </Typography>
                    </Stack>
                }
                variant={variant}
            />
            {renderUpdateGoLiveDateDialog()}
        </>
    );
};
